export function assert(value: any, message?: string): asserts value {
  if (!value) {
    throw new TypeError(message || `Expects value ${value} to be defined`);
  }
  return value;
}
